<template>
    <div class="dashboard-container">
        <div class="updateGuide" v-if="updateGuide"></div>
        <div class="query-row" :class="[updateGuide && updateGuideStep === 1 ? 'query-row-guide' : '']">
            <!-- 被审计单位名称 -->
            <span class="label">{{ $t('confirmation_dashboard_query_entity') }}:</span>
            <el-select v-model="entityIds" @change="changeCondition" clearable multiple collapse-tags class="input-with-select">
                <el-option v-for="item in entityOpt" :key="item.id" :label="item.entityName" :value="item.id"> </el-option>
            </el-select>
            <!-- 函证类型 -->
            <span class="label mgl20">{{ $t('confirmation_dashboard_query_type') }}:</span>
            <el-select v-model="confirmationType" @change="changeCondition" clearable multiple collapse-tags class="input-with-select">
                <el-option
                    v-for="item in confirmationTypeOpt"
                    :key="item.value"
                    :label="$i18n.locale === 'en' ? item.label_en : item.label_zh"
                    :value="item.value"
                >
                </el-option>
            </el-select>
            <div v-if="updateGuide && updateGuideStep === 1" class="updateGuideTitle">
                <div class="updateGuideTip">
                    <div class="margin-bottom-10">{{ updateGuideStep }}/2</div>
                    <div class="margin-bottom-10">{{ $t(`dashboard_bubble_${updateGuideStep}`) }}</div>
                    <el-button @click="nextClick" class="guide-btn">{{ $t('next') }}</el-button>
                </div>
            </div>
        </div>
        <div class="echarts">
            <!-- 总体进度 -->
            <div class="echarts-item mgr15">
                <div class="echarts-title">
                    <img src="@/assets/img/icon-overview.svg" class="title-icon" />
                    <div>{{ $t('confirmation_dashboard_chart1_title') }}</div>
                </div>
                <div class="echarts-context">
                    <div class="total">
                        <div>{{ $t('total') }}</div>
                        <div class="num">{{ pieTotal }}</div>
                    </div>
                    <div class="pie-echarts">
                        <echarts-pie id="confirmation-pie" :pieData="pieData" />
                    </div>
                </div>
            </div>
            <!-- 进度分析 -->
            <div class="echarts-item mgr15">
                <div class="echarts-title">
                    <img src="@/assets/img/icon-confirmations-type.svg" class="title-icon" />
                    <div>{{ $t('confirmation_dashboard_chart2_title') }}</div>
                </div>
                <div class="echarts-context">
                    <div class="bar-echarts">
                        <echarts-bar id="confirmation-bar1" :renderData="barData1" :chart-style="chartStyle1" />
                    </div>
                </div>
            </div>
            <!-- 待被审计单位签字盖章的函证分析 -->
            <div class="echarts-item" v-if="!showConfirmationReplyStatus" v-loading="tableLoading">
                <div class="echarts-title">
                    <img src="@/assets/img/icon-long-outstanding.svg" class="title-icon" />
                    <div>{{ $t('confirmation_dashboard_chart3_title') }}</div>
                </div>
                <div class="echarts-context">
                    <div class="echarts-header">
                        <div>
                            {{ $t('confirmation_dashboard_chart3_title_part1') }}
                            <el-input
                                v-model="filterDay"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                class="filter-input"
                                @change="changeCondition2"
                            />
                            {{ $t('confirmation_dashboard_chart3_title_part2') }}
                        </div>
                        <div class="total">
                            <div>{{ $t('total') }}</div>
                            <div class="num">{{ barTotal2 }}</div>
                        </div>
                    </div>
                    <div class="bar-echarts2">
                        <echarts-bar id="confirmation-bar2" :renderData="barData2" :chart-style="chartStyle2" :filterDay="filterDay" />
                    </div>
                </div>
            </div>
            <div class="echarts-item" v-else>
                <div class="echarts-title">
                    <img src="@/assets/img/icon-long-outstanding.svg" class="title-icon" />
                    <div>{{ $t('confirmation_replyRate_analysis') }}</div>
                </div>
                <div class="echarts-context">
                    <div class="echarts-comment">{{ $t('confirmation_replyRate_analysis_comment') }}</div>
                    <div class="echarts-header">
                        <div class="total">
                            <div>{{ $t('total') }}</div>
                            <div class="num">{{ barTotal4 }}%</div>
                        </div>
                    </div>
                    <div class="bar-echarts2">
                        <echarts-bar id="confirmation-bar3" :renderData="barData4" :chart-style="chartStyle2" />
                    </div>
                </div>
            </div>
        </div>
        <div class="echarts-item4" v-if="showConfirmationReplyStatus">
            <div class="echarts-title">
                <div class="left">
                    <img src="@/assets/img/icon-overview.svg" class="title-icon" />
                    <div>{{ $t('confirmation_echart4_title') }}</div>
                    <div class="echarts-item4-guide">
                        <div class="echarts-item4-subtitle" v-html="$t('echarts4_subtitle')"></div>
                        <div v-if="updateGuide && updateGuideStep === 2" class="updateGuideTitle">
                            <div class="updateGuideTip">
                                <div class="margin-bottom-10">{{ updateGuideStep }}/2</div>
                                <div class="margin-bottom-10">{{ $t(`dashboard_bubble_${updateGuideStep}`) }}</div>
                                <el-button @click="gotItClick" class="guide-btn">{{ $t('gotIt') }}</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <el-button class="wl-green table-btn" @click="exportPendingAnalyse" :loading="exportLoading">{{
                        $t('export_list')
                    }}</el-button>
                </div>
            </div>
            <div class="echarts-container">
                <div class="left">
                    <div class="notice">
                        <span class="redstar">*</span>
                        <span class="text">{{ $t('you_can_input_day_count_will_auto_refresh') }}</span>
                    </div>
                    <div class="input-container">
                        <div class="input-table">
                            <div class="td-row td-row-0">
                                <div class="td-left"></div>
                                <div class="td-right">{{ $t('please_input') }}*</div>
                            </div>
                            <div class="td-row td-row-1">
                                <div class="td-left">{{ $t('confirmation_bar4_inputtip_1') }}</div>
                                <div class="td-right">
                                    <el-input
                                        class="td-right-input"
                                        v-model="confirmation_bar4_input_1"
                                        placeholder="5"
                                        @blur="getPendingAnalyse"
                                    ></el-input>
                                </div>
                            </div>
                            <div class="td-row td-row-2">
                                <div class="td-left">{{ $t('confirmation_bar4_inputtip_2') }}</div>
                                <div class="td-right">
                                    <el-input
                                        class="td-right-input"
                                        v-model="confirmation_bar4_input_2"
                                        placeholder="15"
                                        @blur="getPendingAnalyse"
                                    ></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right" v-loading="barData3Loading">
                    <EchartsXBar
                        class="right1"
                        :renderData="barData3"
                        :confirmation_bar4_input_1="confirmation_bar4_input_1"
                        :confirmation_bar4_input_2="confirmation_bar4_input_2"
                    ></EchartsXBar>
                    <div class="right2">
                        <div class="right2-title">{{ $t('confirmation_count') }}</div>
                        <div class="right2-count-num-1">{{ chart4ConfirmationCount[0] }}</div>
                        <div class="right2-count-num-2">{{ chart4ConfirmationCount[1] }}</div>
                    </div>
                </div>
            </div>
            <!-- <div class="charttip">
                <div class="block">
                    <div class="color-bank"></div>
                    <div class="text">{{ $t('confirmation_type._1_all') }}</div>
                </div>
                
                <div class="block">
                    <div class="color-nobank"></div>
                    <div class="text">{{ $t('confirmation_type._0') }}</div>
                </div>
                
            </div> -->
        </div>
        <!-- 表格：各家被审计单位的函证进度 -->
        <div class="table">
            <div class="table-title">
                <div class="left">
                    {{ $t('confirmation_dashboard_table_title') }}
                </div>
                <div class="right">
                    <el-button class="wl-green table-btn" @click="exportProgress" :loading="exportLoading2">{{
                        $t('export_list')
                    }}</el-button>
                </div>
            </div>
            <DashboardTable
                v-loading="tableLoading"
                :table-data="tableData"
                :table-data-source="tableDataSource"
                :showConfirmationReplyStatus="showConfirmationReplyStatus"
            />
            <el-pagination
                v-if="tablePager.total > 50"
                class="wl-pagination"
                :current-page="tablePager.pageNum"
                :page-size="tablePager.pageSize"
                @size-change="onSizeChange"
                @current-change="onPageChange"
                :page-sizes="[50, 100, 200]"
                layout="prev, pager, next, sizes, total"
                :total="tablePager.total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import EchartsPie from './EchartsPie'
import EchartsBar from './EchartsBar'
import EchartsXBar from './EchartsXBar'
import DashboardTable from './DashboardTable'
import API from '@/api'
import { loading } from '@/utils'
import { mapGetters } from 'vuex'

export default {
    name: 'Dashboard',
    components: {
        EchartsPie,
        EchartsBar,
        DashboardTable,
        EchartsXBar
    },
    props: {},
    data() {
        return {
            timer: null,
            entityOpt: [],
            entityIds: [],
            confirmationType: [],
            confirmationTypeOpt: [
                {
                    label_en: 'Bank confirmation',
                    label_zh: '银行',
                    value: '1'
                },
                {
                    label_en: 'Non-bank confirmation',
                    label_zh: '非银行',
                    value: '0'
                }
            ],
            filterDay: 5,
            pieData: [],
            pieTotal: 0,
            barData1: {},
            barAverageData1: {
                bank: 0,
                non_bank: 0
            },
            chartStyle1: {
                grid: {
                    left: 0,
                    right: 0,
                    top: 20,
                    bottom: 30
                },
                legend: {
                    show: true
                },
                xAxis: {
                    axisLabel: {
                        width: this.$i18n.locale === 'zh' ? 75 : 68,
                        fontSize: this.$i18n.locale === 'zh' ? 11 : 10
                    }
                },
                ser: {
                    barWidth: '20%',
                    label: {
                        show: true,
                        position: 'top',
                        color: '#333333',
                        fontFamily: 'KPMG',
                        fontWeight: 'bold',
                        fontSize: 12
                    }
                }
            },
            barData2: {},
            barTotal2: 0,
            chartStyle2: {
                grid: {
                    left: 0,
                    right: 0,
                    top: 20,
                    bottom: 5
                },
                legend: {
                    show: false
                },
                xAxis: {
                    axisLabel: {
                        width: this.$i18n.locale === 'zh' ? 170 : 160,
                        fontSize: this.$i18n.locale === 'zh' ? 11 : 10
                    }
                },
                ser: {
                    barWidth: '20%',
                    label: {
                        show: true,
                        position: 'top',
                        color: '#333333',
                        fontFamily: 'KPMG',
                        fontWeight: 'bold',
                        fontSize: 12
                    }
                }
            },
            tableLoading: false,
            tableData: [],
            tablePager: {
                pageNum: 1,
                pageSize: 50,
                total: 0
            },
            tableDataSource: [],
            exportLoading: false,
            exportLoading2: false,
            barData3: {},
            barData3Loading: false,
            confirmation_bar4_input_1: '',
            confirmation_bar4_input_2: '',
            barData4: {},
            barTotal4: 0,
            showConfirmationReplyStatus: false,
            updateGuideStep: 0,
            updateGuide: false
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite'
        }),
        chart4ConfirmationCount() {
            let total1 = 0
            let total2 = 0
            if (this.barData3 && this.barData3.userSetOverdueDays) {
                this.barData3.userSetOverdueDays.forEach((v) => {
                    total1 += v.amount
                })
            }
            if (this.barData3 && this.barData3.userProcessOverdueDays) {
                this.barData3.userProcessOverdueDays.forEach((v) => {
                    total2 += v.amount
                })
            }
            return [total1, total2]
        }
    },
    async mounted() {
        await this.getTileGeneral()
        this.getBehavior()
        this.getEntityOpt()
        this.getDashboard()
    },
    methods: {
        async getTileGeneral() {
            const _loading = loading()
            _loading.load()
            return API.general
                .siteTilesGeneral({ siteId: this.getSite.siteId })
                .then((res) => {
                    if (res.code == '1') {
                        this.showConfirmationReplyStatus = res.data.showConfirmationReplyStatus
                    }
                })
                .finally(() => {
                    _loading.close()
                })
        },
        getEntityOpt: async function () {
            const { code, data } = await API.confirmation.getEntity({ siteId: this.getSite.siteId })
            if (code == '1') {
                this.entityOpt = data
            } else {
                this.$message.error(this.$t(code))
            }
        },
        changeCondition() {
            if (this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.getDashboard()
            }, 600)
        },
        changeCondition2() {
            if (this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.getDashboard2()
            }, 600)
        },
        async exportPendingAnalyse() {
            // 咋还不对呢
            let params = {
                siteId: this.getSite.siteId,
                entityId: this.entityIds,
                type: this.confirmationType,
                userSetOverdueDays: this.confirmation_bar4_input_1 ? this.confirmation_bar4_input_1 : 5,
                userProcessOverdueDays: this.confirmation_bar4_input_2 ? this.confirmation_bar4_input_2 : 15
            }
            this.exportLoading = true
            const res = await API.confirmation.exportPendingAnalyse(params)
            this.exportLoading = false
            let blob = new Blob([res])
            let url = window.URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', 'AuditConfirmationPendingAnalyse.xlsx')
            document.body.appendChild(link)
            link.click()
        },
        async exportProgress() {
            let params = {
                siteId: this.getSite.siteId,
                entityId: this.entityIds,
                type: this.confirmationType
                // startPendingDay: this.filterDay,
                // endPendingDay: 99999
            }
            this.exportLoading2 = true
            const res = await API.confirmation.exportProgressByEntity(params)
            this.exportLoading2 = false
            let blob = new Blob([res])
            let url = window.URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', 'AuditConfirmationProgressOfEachAuditedEntity.xlsx')
            document.body.appendChild(link)
            link.click()
        },
        getDashboard() {
            this.tableLoading = true
            let params = {
                siteId: this.getSite.siteId,
                entityId: this.entityIds,
                type: this.confirmationType,
                userSetOverdueDays: this.filterDay
            }
            API.confirmation.getDashboard(params).then((res) => {
                if (res.code === '1') {
                    if (this.showConfirmationReplyStatus) {
                        this.dealBarData1(res.data.confirmationByTypeAndStatusSubBOList)
                        this.dealPieData(res.data.confirmationByEntityAndStatusSubBOList)
                        this.dealTableData(res.data.confirmationByEntityAndStatusSubBOList)
                    } else {
                        this.dealBarData2(res.data.confirmationByTypeAndDaysBOList)

                        this.dealBarData1(res.data.confirmationByTypeAndStatusBOList)
                        this.dealPieData(res.data.confirmationByEntityAndStatusBOList)
                        this.dealTableData(res.data.confirmationByEntityAndStatusBOList)
                    }
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.tableLoading = false
            })

            if (this.showConfirmationReplyStatus) {
                this.getPendingAnalyse()
            }
        },
        getPendingAnalyse() {
            let params = {
                siteId: this.getSite.siteId,
                entityId: this.entityIds,
                type: this.confirmationType
            }
            this.barData3Loading = true
            API.confirmation
                .pendingAnalyse({
                    userSetOverdueDays: this.confirmation_bar4_input_1 ? this.confirmation_bar4_input_1 : 5,
                    userProcessOverdueDays: this.confirmation_bar4_input_2 ? this.confirmation_bar4_input_2 : 15,
                    ...params
                })
                .then((res) => {
                    this.barData3Loading = false

                    this.barData3 = res.data
                })
            API.confirmation.replyRate(params).then((res) => {
                this.dealBarData4(res.data.detailReplyRate)
                this.barTotal4 = res.data.summaryReplyRate
            })
        },
        dealBarData4(dataList) {
            let temp = {
                xData: [],
                dataList: []
            }
            let list = [0, 0]
            if (dataList && dataList.length > 0) {
                dataList.forEach((item) => {
                    if (item.confirmationType === '1') {
                        temp.xData.unshift(this.$t('confirmation_type._1_all'))
                        temp.dataList.unshift({ value: item.replyRate, name: this.$t('confirmation_type._1_all') })
                    } else if (item.confirmationType === '0') {
                        temp.xData.unshift(this.$t('confirmation_type._0'))
                        temp.dataList.unshift({ value: item.replyRate, name: this.$t('confirmation_type._0') })
                    }
                })
            }
            this.barData4 = {
                ...temp
            }
        },
        getDashboard2() {
            this.tableLoading = true
            let params = {
                siteId: this.getSite.siteId,
                entityId: this.entityIds,
                type: this.confirmationType,
                startPendingDay: this.filterDay,
                endPendingDay: 999999
            }
            API.confirmation.getDashboard(params).then((res) => {
                if (res.code === '1') {
                    this.dealBarData2(res.data.confirmationByTypeAndDaysBOList)
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.tableLoading = false
            })
        },
        dealPieData(dataList) {
            let draft = 0
            let pendingFor = 0
            let sentToKPMG = 0
            let completed = 0
            let status5 = 0
            let status6 = 0

            if (dataList && dataList.length > 0) {
                dataList.forEach((item) => {
                    draft += item.draftNum || 0
                    pendingFor += item.pendingForClientAuthorisationNum || 0
                    sentToKPMG += item.authorisedConfirmationSentToKPMGNum || 0
                    completed += item.authorizationCompletedNum || 0
                    status5 += item.confirmationsReceivedAndProcessedByAddresseesNum || 0
                    status6 += item.confirmationsReceivedFromAddresseesNum || 0
                })
            }
            this.pieData = this.showConfirmationReplyStatus
                ? [
                      { value: draft, name: this.$t('confirmation_status._1') },
                      { value: pendingFor, name: this.$t('confirmation_status._2') },
                      { value: sentToKPMG, name: this.$t('confirmation_status._3_3') },
                      { value: completed, name: this.$t('confirmation_status._4') },
                      { value: status5, name: this.$t('confirmation_status._5') },
                      { value: status6, name: this.$t('confirmation_status._6') }
                  ]
                : [
                      { value: draft, name: this.$t('confirmation_status._1') },
                      { value: pendingFor, name: this.$t('confirmation_status._2') },
                      { value: sentToKPMG, name: this.$t('confirmation_status._3_3') },
                      { value: completed, name: this.$t('confirmation_status._4') }
                  ]
            this.pieTotal = this.showConfirmationReplyStatus
                ? draft + pendingFor + sentToKPMG + completed + status5 + status6
                : draft + pendingFor + sentToKPMG + completed
        },
        dealBarData1(dataList) {
            let temp = {
                legends: [],
                dataList: []
            }
            let xData = []
            if (dataList && dataList.length > 0) {
                dataList.forEach((item) => {
                    let draft = item.draftNum || 0
                    let pendingFor = item.pendingForClientAuthorisationNum || 0
                    let sentToKPMG = item.authorisedConfirmationSentToKPMGNum || 0
                    let completed = item.authorizationCompletedNum || 0
                    let average = item.authorizationAverageDays || 0

                    if (item.confirmationType === '1') {
                        temp.legends.push(this.$t('confirmation_type._1_all'))

                        this.barAverageData1.bank = average
                    } else if (item.confirmationType === '0') {
                        temp.legends.push(this.$t('confirmation_type._0'))
                        this.barAverageData1.non_bank = average
                    }
                    if (this.showConfirmationReplyStatus) {
                        let confirmationsReceivedAndProcessedByAddresseesNum = item.confirmationsReceivedAndProcessedByAddresseesNum || 0
                        let confirmationsReceivedFromAddresseesNum = item.confirmationsReceivedFromAddresseesNum || 0
                        temp.dataList.push([
                            {
                                value: draft,
                                name: this.$t('confirmation_status._1')
                            },
                            {
                                value: pendingFor,
                                name: this.$t('confirmation_status._2')
                            },
                            {
                                value: sentToKPMG,
                                name: this.$t('confirmation_status._3_3')
                            },
                            {
                                value: completed,
                                name: this.$t('confirmation_status._4')
                            },
                            {
                                value: confirmationsReceivedAndProcessedByAddresseesNum,
                                name: this.$t('confirmation_status._5')
                            },
                            {
                                value: confirmationsReceivedFromAddresseesNum,
                                name: this.$t('confirmation_status._6')
                            }
                        ])
                        xData = [
                            this.$t('confirmation_status._1'),
                            this.$t('confirmation_status._2'),
                            this.$t('confirmation_status._3_3'),
                            this.$t('confirmation_status._4'),
                            this.$t('confirmation_status._5'),
                            this.$t('confirmation_status._6')
                        ]
                    } else {
                        temp.dataList.push([
                            {
                                value: draft,
                                label: this.$t('confirmation_status._1')
                            },
                            {
                                value: pendingFor,
                                label: this.$t('confirmation_status._2')
                            },
                            {
                                value: sentToKPMG,
                                label: this.$t('confirmation_status._3_3')
                            },
                            {
                                value: completed,
                                label: this.$t('confirmation_status._4')
                            }
                        ])
                        xData = [
                            this.$t('confirmation_status._1'),
                            this.$t('confirmation_status._2'),
                            this.$t('confirmation_status._3_3'),
                            this.$t('confirmation_status._4')
                        ]
                    }
                })
            }
            this.barData1 = {
                xData,
                ...temp
            }
        },
        dealBarData2(dataList) {
            let temp = {
                xData: [],
                dataList: []
            }
            let list = [0, 0]
            let total = 0
            if (dataList && dataList.length > 0) {
                dataList.forEach((item) => {
                    if (item.confirmationType === '1') {
                        temp.xData.push(this.$t('confirmation_type._1_all'))
                        temp.dataList.push({ value: item.amount, name: this.$t('confirmation_type._1_all') })
                    } else if (item.confirmationType === '0') {
                        temp.xData.push(this.$t('confirmation_type._0'))
                        temp.dataList.push({ value: item.amount, name: this.$t('confirmation_type._0') })
                    }
                    total += item.amount
                })
            }
            this.barData2 = {
                ...temp
            }
            this.barTotal2 = total
        },
        dealTableData(data) {
            this.tableDataSource = data || []
            if (this.tableDataSource.length > 0) {
                this.tableDataSource.forEach((item) => {
                    item.draftNum = item.draftNum || 0
                    item.pendingForClientAuthorisationNum = item.pendingForClientAuthorisationNum || 0
                    item.authorisedConfirmationSentToKPMGNum = item.authorisedConfirmationSentToKPMGNum || 0
                    item.authorizationCompletedNum = item.authorizationCompletedNum || 0
                    item.total =
                        item.draftNum +
                        item.pendingForClientAuthorisationNum +
                        item.authorisedConfirmationSentToKPMGNum +
                        item.authorizationCompletedNum

                    if (this.showConfirmationReplyStatus) {
                        item.status5 = item.confirmationsReceivedAndProcessedByAddresseesNum || 0
                        item.status6 = item.confirmationsReceivedFromAddresseesNum || 0
                        item.total += item.status5 + item.status6
                    }
                })
            }
            this.tablePager.total = this.tableDataSource.length
            // 数据大于50条展现分页
            if (this.tableDataSource.length > 50) {
                this.sliceTableData()
            } else {
                this.tableData = [...this.tableDataSource]
            }
        },
        sliceTableData() {
            let start = (this.tablePager.pageNum - 1) * this.tablePager.pageSize
            let end = this.tablePager.pageNum * this.tablePager.pageSize
            this.tableData = this.tableDataSource.slice(start, end)
        },
        onSizeChange(size) {
            this.tablePager.pageNum = 1
            this.tablePager.pageSize = size
            this.sliceTableData()
        },
        onPageChange(page) {
            this.tablePager.pageNum = page
            this.sliceTableData()
        },
        getBehavior() {
            API.common.queryBehavior().then((res) => {
                if (res.code === '1') {
                    this.updateGuide = res.data.confirmationViewNoticeFlag === 0
                    if (this.updateGuide) this.updateGuideStep = 1
                    // this.updateGuide = true
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        nextClick() {
            this.updateGuideStep++
        },
        gotItClick() {
            let param = {
                confirmationViewNoticeFlag: 1
            }
            API.common.updateBehavior(param).then((res) => {
                if (res.code === '1') {
                    this.updateGuide = false
                    this.updateGuideStep = 0
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        }
    },
    beforeDestroy() {
        clearTimeout(this.timer)
    }
}
</script>

<style scoped>
.dashboard-container {
    width: calc(80vw - 40px);
}
.dashboard-container .query-row {
    height: 35px;
    display: flex;
    align-items: center;
    float: left;
    position: relative;
}

.query-row .label {
    font-size: 14px;
    margin-right: 5px;
}

.input-with-select {
    width: 370px;
}

.mgl20 {
    margin-left: 22px;
}

.echarts {
    width: 100%;
    height: 540px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
}

.echarts .echarts-item {
    width: calc((100% - 30px) / 3);
    height: 100%;
    background-color: #fff;
    border-radius: 5px;
}

.echarts .echarts-item.mgr15 {
    margin-right: 15px;
}

.echarts-title {
    padding: 10px;
    height: 52px;
    font-weight: bold;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(22, 36, 59, 0.1);
}

.echarts-title .title-icon {
    height: 32px;
    width: 32px;
    margin-right: 22px;
    flex-shrink: 0;
}

.echarts-item4 .echarts-title {
    flex-direction: row;
    justify-content: space-between;
}
.echarts-item4 .echarts-title .left {
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 32px;
}
.echarts-item4 .echarts-item4-subtitle {
    font-size: 12px;
    font-weight: 400;
    margin-left: 5px;
    position: inherit;
}

.echarts-context {
    padding: 10px;
    height: calc(100% - 52px);
}
.echarts-context .echarts-comment {
    font-size: 12px;
    color: gray;
}
.echarts-context .echarts-header {
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.total {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.total .num {
    font-weight: bold;
    font-size: 40px;
    color: #333333;
    margin-left: 10px;
}

.filter-input {
    width: 65px;
}

.pie-echarts,
.bar-echarts2 {
    width: 100%;
    height: calc(100% - 40px);
}

.bar-echarts {
    width: 100%;
    height: 100%;
}

.des {
    font-size: 12px;
    height: 36px;
    line-height: 18px;
    text-align: center;
    color: #333333;
}

.echarts-item4 {
    width: 100%;
    height: 550px;
    min-height: 450px;
    background-color: #fff;
    border-radius: 5px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
}
.echarts-item4 .echarts-container {
    width: 100%;
    height: calc(100% - 52px);
    background-color: #fff;
    border-radius: 5px;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
}
.echarts-item4 .echarts-container .left {
    width: 40%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}
.echarts-item4 .echarts-container .left .notice {
    width: 100%;
    height: 40px;
    /* margin-left: 20PX; */
    font-size: 12px;
    position: absolute;
    left: 33px;
    top: 10px;
}
.echarts-item4 .echarts-container .left .notice .redstar {
    color:#fd349c;
}
.echarts-item4 .echarts-container .left .notice .text {
    margin-left: 5px;
}
.echarts-item4 .echarts-container .left .input-container {
    width: 100%;
    height: calc(100% - 40px);
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    /* align-items: center; */
    position: absolute;
    top: 0;
    left: 0;
}
.echarts-item4 .echarts-container .left .input-container .input-table {
    width: 85%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 40px;
    display: flex;
    flex-direction: column;
}
.echarts-item4 .echarts-container .left .input-container .input-table .td-row {
    position: absolute;
    right: 0;
    width: 100%;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-right: 10%;
}
.echarts-item4 .echarts-container .left .input-container .td-left {
    width: 70%;
}
.echarts-item4 .echarts-container .left .input-container .td-right {
    width: 20%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.echarts-item4 .echarts-container .left .input-container .input-table .td-row:nth-of-type(1) {
    top: 12%;
    margin-right: 8%;
}
.echarts-item4 .echarts-container .left .input-container .input-table .td-row:nth-of-type(2) {
    top: 38%;
    width: 90%;
}
.echarts-item4 .echarts-container .left .input-container .input-table .td-row:nth-of-type(3) {
    top: 72%;
    width: 90%;
}
.echarts-item4 .echarts-container .left .input-container .input-table .td-row:nth-of-type(1) .td-left {
    width: 0;
}
.echarts-item4 .echarts-container .left .input-container .input-table .td-row:nth-of-type(1) .td-right {
    width: 100%;
    text-align: right;
}
.echarts-item4 .echarts-container .left .input-container .td-right .td-right-input {
    width: 100%;
}
.echarts-item4 .echarts-container .left .input-container .td-right .td-right-input ::v-deep .el-input__inner {
    font-size: 18px;
}
.echarts-item4 .echarts-container .right {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: row;
}
.echarts-item4 .echarts-container .right .right1 {
    width: 85%;
    height: 100%;
}
.echarts-item4 .echarts-container .right .right2 {
    width: 15%;
    height: 100%;
    position: relative;
}
.echarts-item4 .echarts-container .right .right2 .right2-title {
    position: absolute;
    width: 60px;

    top: 12%;
    left: 0;
    font-size: 14px;
}
.echarts-item4 .echarts-container .right .right2 .right2-count-num-1,
.echarts-item4 .echarts-container .right .right2 .right2-count-num-2 {
    position: absolute;
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    left: 0;
    font-size: 16px;
    font-weight: 600;
}
.echarts-item4 .echarts-container .right .right2 .right2-count-num-1 {
    top: 33%;
}
.echarts-item4 .echarts-container .right .right2 .right2-count-num-2 {
    top: 65%;
}
.echarts-item4 .charttip {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 40%;
    width: 51%;
    justify-content: center;
}
.echarts-item4 .charttip .block {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.echarts-item4 .charttip .block:not(:last-of-type) {
    margin-right: 30px;
}

.echarts-item4 .charttip .block .color-bank,
.echarts-item4 .charttip .block .color-nobank {
    width: 20px;
    height: 20px;
}
.echarts-item4 .charttip .block .color-bank {
    background-color: #0070c0;
}
.echarts-item4 .charttip .block .color-nobank {
    background-color: #00c0ae;
}
.echarts-item4 .charttip .block .text {
    margin-left: 10px;
}
.table {
    margin-top: 10px;
    width: 100%;
    background-color: #fff;
    border-radius: 5px;
    padding: 15px;
}

.table .table-title {
    font-weight: bold;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    position: relative;
    padding-left: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.table .table-title::before {
    content: '';
    display: block;
    height: 40%;
    width: 3px;
    position: absolute;
    left: 0;
    top: 15%;
    background-color: #3879eb;
}

.updateGuide {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 2017;
}
.updateGuideTitle {
    position: absolute;
    background-color: white;
    z-index: 2018;
    border-radius: 10px;
    border: 2px solid #3879eb !important;
}
.query-row-guide .updateGuideTitle {
    width: calc(100% + 2px);
    border-radius: 5px;
    height: 35px;
}
.updateGuideTitle .updateGuideTip {
    z-index: 2018;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    left: 0;
    top: 42px;
    width: 240px;
    border-radius: 10px;
    text-align: left;
    font-size: 14px;
    line-height: normal;
}
.query-row-guide .label,
.query-row-guide .input-with-select,
.echarts-item4-guide .echarts-item4-subtitle {
    z-index: 2020;
}
.margin-bottom-10 {
    margin-bottom: 10px;
}
.guide-btn {
    float: right;
    color: #3879eb;
}
.echarts-item4-guide {
    position: relative;
}
.echarts-item4-guide .updateGuideTitle {
    height: 32px;
    width: calc(100% + 4px);
    top: 0;
}
</style>
